export default {
  title: '请选择入职引导页与问卷',
  label: {
    inductionPage: '引导页',
    questionnaire: '问卷',
    onboardDate: '入职日期',
    notificationEmail: '提醒邮箱',
    onboardingInvited: '入职问卷已邀请'
  },
  btn: {
    addEmail: '确认添加邮箱'
  },
  message: {
    atLeastOneInductionPageOrQuestionnaire: '请至少选择一套引导页或者一套问卷',
    inviteSuccess: '邀请成功',
    hasInvited: '已邀请过或者已经完成入职问卷',
    inviteFail: '邀请失败'
  }
}
